import React, { useState } from 'react';
import { rem, createStyles, Flex, Title, Tabs, Box } from '@mantine/core';
import { IconMedal, IconGridDots, IconTicket } from '@tabler/icons-react';
import BenefitsTab from './benefits/BenefitsTab';
import TypesTab from './benefits/TypesTab';
import CouponsTab from './benefits/CouponsTab';
import { useSelector } from 'react-redux';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: theme.spacing.md,
		height: '100%',
	},
	th: {
		padding: '0 !important',
	},
	control: {
		width: '100%',
		padding: `${theme.spacing.xs} ${theme.spacing.md}`,
		'&:hover': {
			backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[1],
		},
	},
	icon: {
		width: rem(21),
		height: rem(21),
		borderRadius: rem(21),
	},
}));

const Benefits = () => {

	// State and hooks
	const [activeTab, setActiveTab] = useState('benefits');
	const { classes } = useStyles();
	const { tenant } = useSelector(state => state.authData);

	return (
		<>
			<Box className="mainContainer">
				{/* Content */}
				<Flex
					direction="column"
					justify="space-between"
					className={classes.container}
				>
					{/* Title */}
					<Title mb="xl">
						Beneficios
					</Title>
					{/* Tabs */}
					<Tabs
						value={activeTab}
						onTabChange={setActiveTab}
					>
						{/* Tab Selector */}
						<Tabs.List>
							<Tabs.Tab value="benefits" icon={<IconMedal size="1.2rem" stroke={1.5} />}>Beneficios</Tabs.Tab>
							<Tabs.Tab value="types" icon={<IconGridDots size="1.2rem" stroke={1.5} />}>Tipos</Tabs.Tab>
							<Tabs.Tab value="coupons" icon={<IconTicket size="1.2rem" stroke={1.5} />}>Cupones</Tabs.Tab>
						</Tabs.List>
						{/* Content */}
						<Tabs.Panel value="benefits" pt="xs">
							<BenefitsTab />
						</Tabs.Panel>
						<Tabs.Panel value="types" pt="xs">
							<TypesTab />
						</Tabs.Panel>
						<Tabs.Panel value="coupons" pt="xs">
							<CouponsTab />
						</Tabs.Panel>
					</Tabs>
				</Flex>
			</Box>
		</>
	);

}

export default Benefits;
